import { render, staticRenderFns } from "./ResumeBlock.vue?vue&type=template&id=c3fd205e"
import script from "./ResumeBlock.vue?vue&type=script&lang=js"
export * from "./ResumeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports